// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'toolbox-open';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7.148 5.74a3.22 3.22 0 0 1-1.262 1.445l.742 3.87H4.31l-.66-3.442a3.22 3.22 0 0 1-1.133-5.916l.46 2.398L4.309 5l.904-1.332-.46-2.398a3.22 3.22 0 0 1 2.394 4.47zm5.247-4.018c-.225 1.009-1.412 1.682-3.037 1.32L9.04 4.469l7.604 1.69.74-3.327zm-1.515 9.333 1.31-5.885 2.165.482-1.262 5.403zm6.558 4.943v-4.943H.563v4.943c0 .405.328.733.733.733h15.408a.734.734 0 0 0 .734-.733z' />
    <path d='M10.1 12.156a1.1 1.1 0 1 1-2.2 0v-1.1h2.2z' />
  </g>
);

export const viewBox = '0 0 18 18';
